import type { UserInvitation } from "@/types/userInvitation";

/**
 * Resolves the invitation's status for the /welcome route, treating a past
 * `willExpireAt` as expired even when the stored `status` still says otherwise.
 *
 * The stored `status` only becomes `expired` when an admin sweeps the collection;
 * a token-holder on /welcome cannot `list` userInvitations (rules deny enumeration),
 * so the sweep never ran for them. Deriving expiry from the document the holder
 * already has makes the check work without a privileged query.
 */
export function resolveInvitationStatus(
  invitation: Pick<UserInvitation, "status" | "willExpireAt">,
  now: Date = new Date()
): UserInvitation["status"] {
  if (invitation.status === "accepted" || invitation.status === "expired") {
    return invitation.status;
  }

  const expiresAt = invitation.willExpireAt?.toDate?.();
  if (expiresAt instanceof Date && expiresAt.getTime() < now.getTime()) {
    return "expired";
  }

  return invitation.status;
}
